export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const RESET_AUTH_TOKEN = 'RESET_AUTH_TOKEN';
